import { render, staticRenderFns } from "./dutyorder.vue?vue&type=template&id=a89bfc58&"
import script from "./dutyorder.vue?vue&type=script&lang=js&"
export * from "./dutyorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports